;(function () {
  'use strict'

  angular
    .module('contrast.discussion')
    .factory('csStartDiscussionMsgService', csStartDiscussionMsgServiceFactory)

  function csStartDiscussionMsgServiceFactory(csStartDiscussionMessages) {
    var service = {
      getRandom: getRandom
    }

    return service

    function getRandom() {
      return csStartDiscussionMessages[
        _.random(0, csStartDiscussionMessages.length - 1)
      ]
    }
  }
})()
